import { useMemo } from "react";
import type { TypedUseSelectorHook } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import {
    AccountsApi,
    AdminApi,
    AnalyticsApi,
    AuthApi,
    DatadownloadsApi,
    DataImportApi,
    DataPointsApi,
    DataProvidersApi,
    DatauploadApi,
    EmissionEventsApi,
    EmissionRecordsApi,
    EpaSepApi,
    EventFormsApi,
    FormsApi,
    GeodataApi,
    InfrastructureApi,
    MapApi,
    NondetectsApi,
    NotificationsApi,
    SensorDataApi,
    UnmatchedDataApi,
    UserGuideApi,
    WorkflowsApi,
} from "./apiClient";
import type { AppDispatch, RootState } from "./store";

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export const useAccountsApiClient = () => {
    return useMemo(() => AccountsApi(), []);
};

export const useAnalyticsApiClient = () => {
    return useMemo(() => AnalyticsApi(), []);
};

export const useAuthApiClient = () => {
    return useMemo(() => AuthApi(), []);
};

export const useDatauploadApiClient = () => {
    return useMemo(() => DatauploadApi(), []);
};

export const useDatadownloadsApiClient = () => {
    return useMemo(() => DatadownloadsApi(), []);
};

export const useEmissionRecordsApiClient = () => {
    return useMemo(() => EmissionRecordsApi(), []);
};

export const useInfrastructureApiClient = () => {
    return useMemo(() => InfrastructureApi(), []);
};

export const useNondetectsApiClient = () => {
    return useMemo(() => NondetectsApi(), []);
};

export const useDataImportApiClient = () => {
    return useMemo(() => DataImportApi(), []);
};

export const useMapApiClient = () => {
    return useMemo(() => MapApi(), []);
};

export const useEmissionEventsApiClient = () => {
    return useMemo(() => EmissionEventsApi(), []);
};

export const useEpaSepApiClient = () => {
    return useMemo(() => EpaSepApi(), []);
};

export const useDataProvidersApi = () => {
    return useMemo(() => DataProvidersApi(), []);
};

export const useNotificationsApi = () => {
    return useMemo(() => NotificationsApi(), []);
};

export const useDataPointsApi = () => {
    return useMemo(() => DataPointsApi(), []);
};

export const useAdminApiClient = () => {
    return useMemo(() => AdminApi(), []);
};

export const useWorkflowsApiClient = () => {
    return useMemo(() => WorkflowsApi(), []);
};

export const useGeoDataApi = () => {
    return useMemo(() => GeodataApi(), []);
};

export const useSensorDataApi = () => {
    return useMemo(() => SensorDataApi(), []);
};

export const useUserGuideApi = () => {
    return useMemo(() => UserGuideApi(), []);
};

export const useEventFormsApiClient = () => {
    return useMemo(() => EventFormsApi(), []);
};

export const useFormsApiClient = () => {
    return useMemo(() => FormsApi(), []);
};

export const useUnmatchedDataApiClient = () => {
    return useMemo(() => UnmatchedDataApi(), []);
};
